import { isAuthorized } from '../components/AuthorizedAction.js';
import { ENFORCE_EMPLOYEE_TAB_PERMISSIONS } from '../constants/employeeProfile.js';

const ALL_ALLOWED = {
  canSeeStakeholderProfilesTab: true,
};

// What the viewer can use on the employee profile tabs, from the viewer's
// permissions (selectUserPermissions: { action: [subject] }, merged across all
// organizations and projects, without conditions). A missing subject is
// reliable, a present one is not (it may come from another project), so the
// flags only hide controls that would certainly lead to a 403.
// Unknown permissions (not loaded, or the [] fallback) keep everything visible.
export const getEmployeeTabPermissions = (permissions) => {
  if (!ENFORCE_EMPLOYEE_TAB_PERMISSIONS) return ALL_ALLOWED;
  if (
    !permissions ||
    Array.isArray(permissions) ||
    !Object.keys(permissions).length
  ) {
    return ALL_ALLOWED;
  }

  return {
    // the tab lists stakeholders whose profile page also calls
    // stakeholders_and_project_histories and group_participations, which only
    // manage-level abilities allow; read-only viewers would get a 403 (sign-out)
    canSeeStakeholderProfilesTab: isAuthorized(
      'manage',
      'stakeholder',
      permissions
    ),
  };
};
